import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '../../core/components/Alert.tsx';
import Button from '../../core/components/Button.tsx';
import { withIcon } from '../../core/components/Icon.tsx';
import classnames from '../../core/utils/classnames.tsx';

const CloseIcon = withIcon(faXmark);

const CLOSE_COLOR = {
    info: 'text-content-strong',
    warning: 'text-content-warning-strong',
    error: 'text-content-danger-strong',
};

// error only while Worki is blocked; anything Worki can carry on from is a warning or info
export const ChatAlert = ({
    severity,
    title = null,
    text,
    actions = null,
    onClose = null,
    className,
}: {
    severity: 'info' | 'warning' | 'error';
    title?: string | null;
    text: React.ReactNode;
    actions?: React.ReactNode;
    onClose?: (() => void) | null;
    className?: string;
}) => {
    const { t } = useTranslation('chat');
    return (
        <Alert severity={severity} className={classnames('items-start', className)}>
            <div className="flex items-start justify-between gap-3">
                <div className="flex flex-col gap-2">
                    {title && <span className="font-medium">{title}</span>}
                    <span>{text}</span>
                    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
                </div>
                {onClose && (
                    <Button
                        variant="ghost"
                        className={classnames('-my-1 flex-none px-2', CLOSE_COLOR[severity])}
                        onClick={onClose}
                        aria-label={t('usageWarnings.close')}
                    >
                        <CloseIcon />
                    </Button>
                )}
            </div>
        </Alert>
    );
};
